import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["compact", "responsive"],
  _excluded2 = ["children"];
import styled, { css } from 'styled-components';
import { GRID_BREAKPOINT_LARGE } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const responsiveStylesMixin = props => {
  if (!props.responsive) {
    return '';
  }
  return css(["@media (max-width:", "){padding-top:32px;}"], GRID_BREAKPOINT_LARGE);
};

/**
 * @deprecated use marketplace-ui-common
 */
export const InnerSection = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
}).withConfig({
  displayName: "InnerSection",
  componentId: "sc-1gaeujs-0"
})(["padding-top:", "px;padding-bottom:0;&:first-child{padding-top:0;}", ""], props => props.compact ? 32 : 48, responsiveStylesMixin);

/**
 * @deprecated use marketplace-ui-common
 */
export const ResponsiveInnerSection = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  return /*#__PURE__*/_jsx(InnerSection, Object.assign({}, rest, {
    responsive: true,
    children: children
  }));
};
export default InnerSection;